import { Fragment } from 'react';

import { markupBlocks } from './markupBlocks.js';

/**
 * Renders the small markup used by exercise statements and tutor answers: `code`, **bold** and
 * *italic*, paragraphs split by blank lines, and ```fenced``` code examples.
 * Deliberately tiny: everything is rendered as React text, so model output can never become HTML.
 */
export function Markup({ text }: { text: string }) {
  return (
    <>
      {markupBlocks(text).map((block, i) =>
        block.kind === 'code' ? (
          <pre key={i} className="code-block">
            <code>{block.code}</code>
          </pre>
        ) : (
          <Paragraph key={i} text={block.text} />
        ),
      )}
    </>
  );
}

function Paragraph({ text: para }: { text: string }) {
  return (
    <p>
      {para.split(/(`[^`]+`|\*\*[^*]+\*\*|\*[^*\s][^*]*\*)/g).map((part, j) => {
        if (part.startsWith('`') && part.endsWith('`') && part.length > 1) {
          return (
            <code key={j} className="inline-code">
              {part.slice(1, -1)}
            </code>
          );
        }
        if (part.startsWith('**') && part.endsWith('**') && part.length > 3) {
          return <strong key={j}>{part.slice(2, -2)}</strong>;
        }
        if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
          return <em key={j}>{part.slice(1, -1)}</em>;
        }
        return <Fragment key={j}>{part}</Fragment>;
      })}
    </p>
  );
}
